import React, { useState } from "react";

interface CheckoutFormProps {
  payWithSarepay: (email:string, amount:number) => void;
}

const CheckoutForm: React.FC<CheckoutFormProps> = ({ payWithSarepay }) => { 
  const [formData, setFormData] = useState({
    email: "", amount: 0
  });
  const [errors, setErrors] = useState({
    email: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setErrors({ ...errors, email: "" });
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); 
    handleClick(formData.amount);
  };

  const handleClick = (amount:number) => {
    const newErrors = { email: "" };

    if (!formData.email || !formData.email.includes("@")) {
      newErrors.email = "Please enter a valid email address";
    }

    if (newErrors.email) {
      setErrors(newErrors);
    } else {
      const updatedFormData = { ...formData, amount };

      setFormData(updatedFormData);
      payWithSarepay(updatedFormData.email, updatedFormData.amount);
    }
   
  }
  return (
    <div className="max-w-md mx-auto mt-4">
      <form onSubmit={handleSubmit}>
        <p className="text-sm py-6 text-[#344054] font-semibold">ENTER EMAIL TO GET YOUR RECEIPT</p>
        <div className="mb-4">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="you@example.com"
            onChange={handleInputChange}
            value={formData.email}
            className={`w-full mt-1 text-gray-600 px-3 py-3 border rounded-md focus:outline-none ${
              errors.email ? "border-red-500" : "border-gray-300"
            }`}
          />
          <p className="text-sm text-red-500">{errors.email}</p>
        </div>

        <div className="py-6 flex lg:flex-row flex-col">
          <button
            type="button"
            id="pay-100"
            className="w-full text-white rounded-xl py-3 mr-4 mb-2 font-semibold shadow-md hover:opacity-90 transition-all"
            style={{
              background:
                "linear-gradient(135deg, var(--SarepayPrimary-color) 0%, var(--Checkout-accent-color) 100%)",
            }}
            onClick={()=>handleClick(100)}
          >
            Pay NGN 100
          </button>
          <button
            type="button"
            id="pay-1000"
            className="w-full text-white rounded-xl py-3 mb-2 font-semibold shadow-md hover:opacity-90 transition-all"
            style={{
              background:
                "linear-gradient(135deg, var(--SarepayPrimary-color) 0%, var(--Checkout-accent-color) 100%)",
            }}
            onClick={()=> handleClick(1000)}
          >
            Pay NGN 1000
          </button>
        </div>
      </form>
    </div>
  );
};

export default CheckoutForm;
